import React, { useState, useEffect } from "react";
import "../../../../../styles/shared/user-list.css";

// components imports
import HelperUserTable from "../../../../../Components/BoltTable/BoltTable";
// apis imports
import { fetchhelperuserwithuserID } from "../../../../../services/AdminServices/Users/users.services";
// library imports
import Backdrop from "@mui/material/Backdrop";
import Modal from "@mui/material/Modal";
import { convertTime } from "../../../../../helpers/helpers";
import { useTranslation } from "react-i18next";

const HelperUserList = ({ open, setOpen, setSnack }) => {
  const { t } = useTranslation("admin");
  const [warehouseHelpers, setWarehouseHelpers] = useState([]);

  const fetchHelperUsers = async (page, perPage, filter) => {
    const response = await fetchhelperuserwithuserID(
      open?.user_id,
      page,
      perPage,
    );
    if (!response.error) {
      setWarehouseHelpers(response?.data?.result);
    } else {
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text:
            response?.error?.response?.data?.message || t("common:messages.somethingWentWrong"),
          severity: "error",
        };
      });
    }
  };

  const columns = [
    {
      id: 0,
      label: t("users.userName"),
      render: (row) => <>{row?.username ?? "-"}</>,
      width: "200px",
    },
    {
      id: 1,
      label: t("users.businessName"),
      render: (row) => <>{row?.business_name ?? "-"}</>,
      width: "200px",
    },
    {
      id: 2,
      label: t("users.email"),
      render: (row) => <>{row?.email ?? "-"}</>,
      width: "200px",
    },
    {
      id: 3,
      label: t("users.phoneNumber"),
      render: (row) => <>{row?.phone_number ?? "-"}</>,
      width: "200px",
    },
    {
      id: 4,
      label: t("users.createdAt"),
      render: (row) => <>{convertTime(row?.created_at)}</>,
      width: "200px",
    },
  ];

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <div className="prdtable__hist_modal">
          <div
            className="prdtable__hist_modalheading history__product_heading  history__main_heading"
            style={{
              border: "none",
            }}
          >
            {t("users.activeHelperUsers")}
          </div>
          <div className="prdtable__hist_modalheading history__product_heading history__sub_heading">
            {open?.name ?? ""} ({open?.code ?? ""})
          </div>
          <div className="prdtable__hist_modalcontent history__product_content">
            <HelperUserTable
              tableId="clientsHelperUsersTableForAdmin"
              message={t("users.noHelperUsersAvailableTo")}
              searchPlaceHolder={t("users.searchNotAvailable")}
              columns={columns}
              data={warehouseHelpers}
              getAllData={fetchHelperUsers}
              disableAutoResizing={true}
              maxHeight="100%"
            />
          </div>
          <div className=" history__product_footer">
            <div className="history__product_footer_btn" onClick={handleClose}>
              x
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default HelperUserList;
